<template>
    <div class="container">
        <b-modal
            :model-value="modalCrear"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.codigo }}</label>
                        <b-form-input
                            v-model="form.codigo"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.descripcion }}</label>
                        <b-form-input
                            v-model="form.descripcion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-row class="text-center">
                    <b-col cols="12 mt-4">
                        <h5>{{ labels.caracteristica }}</h5> 
                    </b-col>
                </b-row>
                <div id="contenedor"></div>
                <b-row class="d-flex justify-content-center">
                    <b-col cols="auto">
                        <b-button style="background-color: #2e507a; width: 30px; height: 30px;" class="md-fab md-primary" @click="addCaracteristica()">
                            <i class="fa-solid fa-plus"></i>
                        </b-button>
                    </b-col>
                </b-row>
                <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                    <b-button
                        class="mr-2 reset-btn-secondary"
                        @click="cierraModal"
                    >
                        {{ labels.close }}
                    </b-button>
                    <b-button
                        class="reset-btn-primary"
                        @click="guardarTipoActivo"
                    >
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import TipoActivo from '../../../services/TipoActivo' 
import TipoActivoCaracteristica from '../../../services/TipoActivoCaracteristica'

export default {
    name:'Crear',
    props:{
        modalCrear: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                codigo: "",
                descripcion: ""
            },
            cantFilaCaract: [],
            listCaracteristicas: [],
            cont: 0
        }
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Crear tipo activo",
                    codigo : "Código",
                    descripcion : "Descripción",
                    caracteristica: "Caracteristicas",
                    save : "Guardar",
                    close : "Cerrar",
                    formInfoTitle: "Datos del tipo de activo",
                    formInfoSubtitle: "Completa la información y guarda el nuevo tipo de activo."
                }
            }else{
                return {
                    title: "Create active type",
                    codigo : "Code",
                    descripcion : "Description",
                    caracteristica: "Characteristics",
                    save : "Sava",
                    close : "Close",
                    formInfoTitle: "Asset type data",
                    formInfoSubtitle: "Complete the information and save the new asset type."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.cleanInp()
            this.$emit('cierraModal',false) 
        },
        async guardarTipoActivo() {

            if (!this.form.codigo || !this.form.descripcion.trim()) {
                return this.$toast.error("Campo(s) pendiente(s) por diligenciar");
            }

            if (this.cantFilaCaract.length === 0) {
                return this.$toast.error("Debe agregar mínimo una característica.");
            }

            for (let i = 0; i < this.cantFilaCaract.length; i++) {

                const codigo = document.getElementById(`caracteristica${i}`).value;
                const descripcion = document.getElementById(`valor${i}`).value;

                if (!codigo || !descripcion.trim()) {
                    return this.$toast.error("Debe diligenciar todas las características.");
                }
            }

            try {

                const info = {
                    codigo: this.form.codigo,
                    descripcion: this.form.descripcion,
                    idUser: this.$store.state.userId
                };

                const res = await TipoActivo.createTipoActivo(info);
                await this.guardaListCar();
                this.$toast.success(res.data.message);
                this.$emit("creado");
                this.cierraModal();

            } catch (error) {

                if (error.response) {
                    this.$toast.error(error.response.data.message);
                } else {
                    console.error(error);
                    this.$toast.error("Ocurrió un error.");
                }

            }
        },
        async guardaListCar() {

            this.listCaracteristicas.length = 0;

            this.cantFilaCaract.forEach((e, ind) => {

                this.listCaracteristicas.push({
                    codTipoActivo: Number(this.form.codigo),
                    codCaracteristica: Number(document.getElementById(`caracteristica${ind}`).value),
                    caracteristica: document.getElementById(`valor${ind}`).value,
                    idUser: this.$store.state.userId
                });

            });

            await TipoActivoCaracteristica.createTipoActivoCaract(
                this.listCaracteristicas
            );

        },
        addCaracteristica(){
            
            // Crear un nuevo div para la fila
            const nuevaFila = document.createElement('div'); 
            
            // Añadir clase para estilo
            nuevaFila.className = 'fila'; 
            
            // Crear la primera celda
            const celda1 = document.createElement('div'); 
            celda1.className = 'celda'; 
            // celda1.textContent = 'Celda 1'; // Contenido de la primera celda 

            const input1 = document.createElement('input'); 
            input1.type = 'number'; // Tipo de input 
            input1.id = 'caracteristica'+this.cont 
            input1.className = 'form-control' 
            input1.placeholder = 'Código' 
            celda1.appendChild(input1); // Añadir el input a la primera celda 
            
            // Crear la segunda celda
            const celda2 = document.createElement('div'); 
            celda2.className = 'celda'; 
            // celda2.textContent = 'Celda 2'; // Contenido de la segunda celda 

            const input2 = document.createElement('input'); 
            input2.type = 'text'; // Tipo de input 
            input2.id = 'valor'+this.cont 
            input2.className = 'form-control' 
            input2.placeholder = 'Descripción' 
            celda2.appendChild(input2); // Añadir el input a la segunda celda 

            // Agregar las celdas a la fila
            nuevaFila.appendChild(celda1); 
            nuevaFila.appendChild(celda2); 
            
            // Agregar la nueva fila al contenedor
            document.getElementById('contenedor').appendChild(nuevaFila); 
            this.cantFilaCaract.push(nuevaFila) 
            this.cont = this.cont + 1
        },
        cleanInp(){
            this.form.codigo = ''
            this.form.descripcion = ''
            this.cantFilaCaract = [];
            this.listCaracteristicas = [];
            this.cont = 0;
            document.getElementById("contenedor").innerHTML = "";
        }
    }
}
</script>

<style>
    .fila { 
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        margin: 10px 0;
    }
    .celda { 
        width: 45%;
    }
</style>
